import get from 'lodash/get';

export const getLenders = (state) => get(state, 'lenders.lenders');
